import React from 'react';
import { Button, Flex, Label, NumericInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import RangeModel from "./RangeModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EVT_CHILD_REMOVE = 'child.remove';
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.aggregations.RangesEditor');
export default class RangesEditor extends React.Component {
  onAddRange = () => {
    const {
      value,
      model,
      onChange,
      eventData
    } = this.props;
    const nVal = model.add(value, RangeModel.create());
    if (onChange) {
      onChange({
        value: nVal,
        data: eventData
      });
    }
  };
  onEvent = evt => {
    const {
      value,
      model,
      onChange,
      eventData
    } = this.props;
    if (evt.type === EVT_CHILD_REMOVE) {
      if (onChange) {
        // If its a remove, remove the item from the list and send it
        const nModel = model.remove(value, evt.range);
        onChange({
          value: nModel,
          data: eventData,
          oldValue: value
        });
      }
    }
  };
  onChildChange = e => {
    const {
      value,
      model,
      onChange,
      eventData
    } = this.props;
    if (onChange) {
      const key = e.data;

      // Replace it, creating a new model
      const nModel = model.set(value, key, e.value);

      // fire the event
      onChange({
        value: nModel,
        data: eventData,
        oldValue: value
      });
    }
  };
  renderRange(range, index) {
    const {
      removable = true,
      eventData
    } = this.props;
    const onChange = evt => {
      const nModel = RangeModel[evt.data](range, evt.value);
      this.onChildChange({
        value: nModel,
        data: index
      });
    };
    const onDelete = removable ? e => {
      this.onEvent({
        type: EVT_CHILD_REMOVE,
        range,
        data: eventData
      });
    } : null;
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      children: [/*#__PURE__*/_jsx(Label, {
        children: t('from')
      }), /*#__PURE__*/_jsx(NumericInput, {
        float: true,
        style: {
          flexGrow: 1
        },
        value: range.from,
        onChange: onChange,
        eventData: "setFrom"
      }), /*#__PURE__*/_jsx(Label, {
        children: t('to')
      }), /*#__PURE__*/_jsx(NumericInput, {
        float: true,
        style: {
          flexGrow: 1
        },
        value: range.to,
        onChange: onChange,
        eventData: "setTo"
      }), removable && /*#__PURE__*/_jsx(Button, {
        variant: "link",
        eventData: range,
        onClick: onDelete,
        icon: tIcon('deleteIcon', 'fa fa-trash')
      })]
    }, `range-${index}`);
  }
  render() {
    const {
      value,
      model,
      className
    } = this.props;
    const ranges = model.getAll(value);
    return /*#__PURE__*/_jsxs("div", {
      className: className,
      children: [ranges.map((range, index) => {
        return this.renderRange(range, index);
      }), /*#__PURE__*/_jsx(Button, {
        icon: tIcon('addIcon', 'fa fa-plus'),
        variant: "tertiary",
        onClick: this.onAddRange,
        children: t('addRange')
      })]
    });
  }
}

// export default function RangesEditor( props ) {
//   const {
//     eventData,
//     value,
//     onChange,
//     model,
//     className
//   } = props

//   return <div className={className}>Ranges Editor</div>
// }